import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Button, Select, Radio, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './OptionForm.css';
import MessageAlert from 'utils';

const { Text } = Typography;

const OptionForm = ({ data, onChange, onRemove }) => {
  const [inputValue, setInputValue] = useState({ ...data });
  const [newOption, setNewOption] = useState({
    option_key: inputValue.option.length + 1,
    option_name: '',
    option_type: inputValue.option_type || 'CHOICE',
    type: inputValue.type || 'DEFAULT',
    option_price: 0,
    count: 0,
    default: false,
  });

  // console.log('data', data);

  // console.log('newOption', newOption);
  // 일반 텍스트 입력을 위한 변경 핸들러
  const handleInputChange = (field, value) => {
    const updated = { ...inputValue, [field]: value };
    setInputValue(updated);
    onChange(updated);
  };

  // 옵션 변경 핸들러
  const handleOptionChange = (field, value, index) => {
    const updatedOptions = inputValue.option.map((opt, i) =>
      i === index
        ? {
            ...opt,
            [field]:
              field === 'option_price'
                ? value === ''
                  ? 0
                  : parseInt(value, 10) || 0 // 숫자 필드일 때만 숫자 변환
                : value, // 그 외의 필드는 그대로 저장
          }
        : opt
    );

    const updated = { ...inputValue, option: updatedOptions };
    setInputValue(updated);
    onChange(updated);
  };

  const handleAddSubOption = () => {
    setInputValue((prev) => {
      const updated = { ...prev, option: [...prev.option, newOption] };
      setNewOption({
        option_key: prev.option.length + 2,
        option_name: '',
        option_type: prev.option_type || 'CHOICE',
        type: prev.type || 'DEFAULT',
        option_price: 0,
        count: 0,
        default: false,
      });
      onChange(updated);
      return updated;
    });
  };

  const handleDefaultChange = (index) => {
    setInputValue((prev) => {
      const updatedOptions = prev.option.map((opt, i) => ({
        ...opt,
        default: i === index ? !opt.default : false,
      }));

      const updated = { ...prev, option: updatedOptions };
      onChange(updated);
      return updated;
    });
  };

  // 하위 옵션 삭제 함수
  const handleRemoveSubOption = (index) => {
    // 하위 옵션이 1개 이상일 때만 삭제 가능
    if (inputValue.option.length > 1) {
      const updatedOptions = inputValue.option.filter((_, i) => i !== index);
      setInputValue((prev) => {
        const updated = { ...prev, option: updatedOptions };
        onChange(updated);
        return updated;
      });
    } else {
      MessageAlert.warning(`더 이상 삭제 할 수 없습니다.`);
    }
  };

  // 상태 초기화 또는 데이터가 변경될 때만 상태 업데이트
  useEffect(() => {
    if (JSON.stringify(inputValue) !== JSON.stringify(data)) {
      setInputValue(data);
    }
    // eslint-disable-next-line
  }, [data]);

  return (
    <div className="option-form-container">
      <Row gutter={[10, 0]}>
        <Col span={7}>
          <Text className="option-form-label">옵션명</Text>
        </Col>
        <Col span={7}>
          <Text className="option-form-label">필수옵션 설정</Text>
        </Col>
        <Col span={7}>
          <Text className="option-form-label">옵션 타입</Text>
        </Col>
        <Col span={3}></Col>

        <Col span={7}>
          <Input
            value={data.option_title}
            size="large"
            count={{ max: 30, show: true }}
            placeholder="옵션명을 입력해주세요"
            onChange={(e) => handleInputChange('option_title', e.target.value)}
          />
        </Col>
        <Col span={5}>
          <Select
            value={inputValue.type || 'DEFAULT'}
            size="large"
            style={{ width: '100%' }}
            onChange={(value) => handleInputChange('type', value)}
            options={[
              { label: '기본 옵션', value: 'DEFAULT' },
              { label: '퍼스널 옵션', value: 'PERSONAL' },
            ]}
          />
        </Col>
        <Col span={5}>
          <Select
            value={inputValue.option_type || 'CHOICE'}
            size="large"
            style={{ width: '100%' }}
            onChange={(value) => handleInputChange('option_type', value)}
            options={[
              { label: '추가옵션', value: 'COUNT' },
              { label: '선택옵션', value: 'CHOICE' },
            ]}
          />
        </Col>
        <Col span={4}>
          <Button
            className="option-form-add-button"
            onClick={handleAddSubOption}
          >
            하위옵션추가
          </Button>
        </Col>
        <Col span={3}>
          <Button
            icon={<CloseOutlined />}
            onClick={onRemove}
            style={{ float: 'right' }}
          />
        </Col>
      </Row>

      <Row gutter={[10, 10]} style={{ marginTop: 10 }}>
        <Col span={8}></Col>
        <Col span={8}></Col>
        <Col span={8}></Col>
        <Col span={8}>
          <Row gutter={[8, 0]}>
            <Col span={10}>
              <Text className="option-form-label">옵션항목</Text>
            </Col>
            <Col span={8}>
              <Text className="option-form-label">옵션항목 금액</Text>
            </Col>
            <Col span={6}></Col>
          </Row>
        </Col>
        <Col span={8}></Col>
        <Col span={8}></Col>
      </Row>

      <Row gutter={[10, 10]} style={{ marginTop: 10 }}>
        {inputValue.option?.map((_item, _index, arr) => (
          <React.Fragment key={`option_item_${_index}`}>
            <Col span={7}>
              <Input
                size="large"
                value={_item.option_name}
                onChange={(e) =>
                  handleOptionChange('option_name', e.target.value, _index)
                }
              />
            </Col>
            <Col span={6}>
              <Input
                size="large"
                value={_item.option_price}
                onChange={(e) =>
                  handleOptionChange(
                    'option_price',
                    parseInt(e.target.value, 10),
                    _index
                  )
                }
              />
            </Col>
            {/* <Col span={6}>
              <Select
                value={_item.option_type || 'COUNT'}
                size="large"
                placeholder="타입 선택"
                style={{ width: '100%' }}
                onChange={(value) =>
                  handleOptionChange('option_type', value, _index)
                }
                options={[
                  { label: '추가옵션', value: 'COUNT' },
                  { label: '선택옵션', value: 'CHOICE' },
                ]}
              />
            </Col> */}
            <Col span={3} alignvertical="center">
              <Radio
                checked={_item.default}
                onClick={() => handleDefaultChange(_index)}
                style={{ textAlign: 'center' }}
              >
                기본값
              </Radio>
            </Col>
            <Col span={2}>
              <Button
                className="option-form-delete-button"
                onClick={() => handleRemoveSubOption(_index)}
              >
                삭제
              </Button>
            </Col>
          </React.Fragment>
        ))}
      </Row>
    </div>
  );
};

export default OptionForm;
